<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'discountTimeList' }">特惠时段</router-link>
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="discountTime">
                <el-form-item label="结束时间:">
                    <el-time-select
                            placeholder="起始时间"
                            value-format="HH:mm"
                            v-model="discountTime.startTime"
                            :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '24:00' }">
                    </el-time-select>
                </el-form-item>
                <el-form-item label="结束时间:">
                    <el-time-select
                            value-format="HH:mm"
                            placeholder="结束时间"
                            v-model="discountTime.endTime"
                            :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '24:00',
                                minTime: discountTime.startTime
                            }">
                    </el-time-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveActivity" size="small">保存</el-button>
                   <!-- <el-button @click="resetForm('formName')" size="small">重置</el-button>-->
                    <el-button @click="$router.back(-1)" size="small">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                discountTime: {},
            }
        },
        created() {
            var _this = this;
            _this.id = _this.$route.query.id;
            _this.id && _this.findDetail();
        },
        methods: {
            findDetail() {
                var _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillTime/detailSeckillTime',
                    data: {
                        seckillTimeId: _this.id,
                    },
                    success(response) {
                        _this.discountTime = response.item
                    }
                })
            },
            saveActivity() {
                var _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillTime/saveSeckillTime',
                    data: _this.discountTime,
                    success(response) {
                        _this.$message({
                            message: '保存成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function () {
                                _this.$router.push({name: 'discountTimeList'});
                            }
                        });
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
        },
    }
</script>